import { clone } from 'lodash'
import template from './index.html'

config.$inject = ['formlyConfigProvider']
function config(formlyConfigProvider) {
  const type = {
    name: 'textarea',
    templateUrl: template,
    wrapper: ['bootstrapLabel', 'bootstrapHasError'],
    defaultOptions: {
      ngModelAttrs: {
        rows: { attribute: 'rows' },
        cols: { attribute: 'cols' }
      }
    },
    apiCheck: check => ({
      templateOptions: {
        rows: check.number.optional,
        cols: check.number.optional
      }
    })
  }
  formlyConfigProvider.setType(type)

  var gridType = clone(type, true)
  gridType.name = 'gridTextarea'
  gridType.wrapper = ['bootstrapHasError']

  formlyConfigProvider.setType(gridType)
}

export default config